// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__gxVtr","left":"InfoRow_left__2lq5i"};